import type { SxProps, Theme } from '@mui/material/styles';

type DealerVehicleDetailStyleMap = {
    loadingContainer: SxProps<Theme>
    root: SxProps<Theme>
    card: SxProps<Theme>
    detailLayout: SxProps<Theme>
    detailMain: SxProps<Theme>
    inlineInfoRow: SxProps<Theme>
    detailRow: SxProps<Theme>
    detailImageWrap: SxProps<Theme>
    tabs: SxProps<Theme>
    tab: SxProps<Theme>
    emptyServices: SxProps<Theme>
    servicesTimeline: SxProps<Theme>
    timelineColumn: SxProps<Theme>
    timelineDot: SxProps<Theme>
    serviceLink: SxProps<Theme>
    serviceHeaderRow: SxProps<Theme>
    serviceMeta: SxProps<Theme>
    serviceDate: SxProps<Theme>
    tabContent: SxProps<Theme>
};

type DealerSectionHeaderStyleMap = {
    root: SxProps<Theme>
};

export const dealerVehicleDetailStyles: DealerVehicleDetailStyleMap = {
    loadingContainer: { display: 'flex', justifyContent: 'center', mt: 8 },
    root: { display: 'flex', flexDirection: 'column', gap: 3 },
    card: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
    detailLayout: { display: 'flex' },
    detailMain: { flex: 1, minWidth: 0 },
    inlineInfoRow: { display: 'flex', alignItems: 'center', gap: 1 },
    detailRow: { px: 3, py: 2.5, display: 'grid', gridTemplateColumns: '160px 1fr', gap: 2, alignItems: 'center' },
    detailImageWrap: { flexShrink: 0, borderLeft: '1px solid', borderColor: 'divider', alignSelf: 'stretch', display: 'flex', alignItems: 'center' },
    tabs: { borderBottom: '1px solid', borderColor: 'divider', px: 2 },
    tab: { textTransform: 'none' },
    emptyServices: { px: 3, py: 4, textAlign: 'center' },
    servicesTimeline: { p: 3, position: 'relative' },
    timelineColumn: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    timelineDot: { width: 32, height: 32, borderRadius: '50%', bgcolor: 'primary.50', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
    serviceLink: { flex: 1, pb: 1, textDecoration: 'none', color: 'inherit', '&:hover': { opacity: 0.75 } },
    serviceHeaderRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 },
    serviceMeta: { display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0 },
    serviceDate: { whiteSpace: 'nowrap' },
    tabContent: { p: 3 },
};

export const dealerSectionHeaderStyles: DealerSectionHeaderStyleMap = {
    root: {
        px: 3,
        py: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        bgcolor: 'grey.50',
        borderBottom: '1px solid',
        borderColor: 'divider',
    },
};

export const getDealerTransferTabStyles = (show: boolean): SxProps<Theme> => ({
    textTransform: 'none',
    display: show ? undefined : 'none',
});

export const getServiceActionBarStyles = (hasServices: boolean): SxProps<Theme> => ({
    px: 3,
    py: 2,
    display: 'flex',
    justifyContent: 'flex-end',
    borderBottom: hasServices ? '1px solid' : 'none',
    borderColor: 'divider',
});

export const getDealerServiceItemStyles = (hasNext: boolean): SxProps<Theme> => ({
    display: 'flex',
    gap: 2,
    pb: hasNext ? 3 : 0,
});

export const getDealerServiceTimelineLineStyles = (): SxProps<Theme> => ({
    width: 2,
    flex: 1,
    bgcolor: 'grey.200',
    my: 0.5,
});

export const serviceTimelineWrenchColor = '#009fe3';
export const warrantyValidIconColor = '#2e7d32';
export const warrantyInvalidIconColor = '#c62828';
